










import { Component, Prop, Watch, Inject, Vue } from "vue-property-decorator";
import { IChartProvider } from "@/models/providers/chart";
import Chart from "chart.js/auto";

@Component
export default class LineChart extends Vue {
  // Inject
  @Inject({ from: "chartProvider" })
  public readonly $chartProvider!: () => IChartProvider;

  @Prop({ required: false, default: () => null })
  public readonly chartData!: any;

  @Prop({ required: false, default: () => null })
  public readonly options!: Record<string, any>;

  @Prop({ default: 320 })
  public height!: number;

  public chart: Chart | null = null;

  public async mounted() {
    const chartData = await this.chartData;
    const options = await this.options;

    const canvas = document.createElement("canvas", {}) as HTMLCanvasElement;
    canvas.style.height = `${this.height}px`;
    this.$el.appendChild(canvas);
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;

    this.chart = new Chart(ctx, {
      type: "line",
      data: chartData,
      options: options
    });
  }

  // Getters
  public get chartProvider() {
    return this.$chartProvider();
  }

  public get hasDataset() {
    return !!this.chart?.data?.datasets?.[0]?.data?.length;
  }

  @Watch("chartData", { deep: true })
  public onChartDataChange() {
    if (!this.chart) return;
    this.chart.update();
  }

  @Watch("chartProvider.hoverIndex", { immediate: true })
  public async onHoverIndexChange() {
    if (this.chart) {
      this.$_.isNil(this.chartProvider.hoverIndex)
        ? this.hoverEmptyArea(this.chart)
        : this.hoverPoint(
            this.chart,
            this.chartProvider.hoverIndex,
            this.chartProvider.hoverDatasetIndex
          );
    }
  }

  @Watch("chartProvider.hoverDatasetIndex", { immediate: true })
  public async onHoverDatasetIndexChange() {
    if (this.chart) {
      this.$_.isNil(this.chartProvider.hoverIndex)
        ? this.hoverEmptyArea(this.chart)
        : this.hoverPoint(
            this.chart,
            this.chartProvider.hoverIndex,
            this.chartProvider.hoverDatasetIndex
          );
    }
  }

  public hasDatasetWithIndex(index) {
    return !!this.chart?.data?.datasets?.[index]?.data?.length;
  }

  public hasDataWithIndex(datasetIndex, index) {
    return (
      !!this.chart?.data?.datasets?.[datasetIndex]?.data?.[index] &&
      !this.$_.get(this.chart.data.datasets[datasetIndex], "isHidden")
    );
  }

  public hoverEmptyArea(chart) {
    const tooltip = chart.tooltip;
    tooltip.setActiveElements([], { x: 0, y: 0 });
    chart.update();
  }

  public hoverPoint(chart, index, datasetIndex) {
    if (
      !this.hasDataset ||
      !this.hasDatasetWithIndex(datasetIndex) ||
      !this.hasDataWithIndex(datasetIndex, index)
    )
      return;
    this.triggerTooltip(chart, index, datasetIndex);
  }

  public triggerTooltip(chart, index, datasetIndex) {
    const tooltip = chart.tooltip;
    const chartArea = chart.chartArea;
    tooltip.setActiveElements(
      [
        {
          datasetIndex,
          index
        }
      ],
      {
        x: (chartArea.left + chartArea.right) / 2,
        y: (chartArea.top + chartArea.bottom) / 2
      }
    );
    chart.update();
  }
}
